import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

// Вбудований окремий сервіс (CRM, Навчання NEW) у робочій області ЕРП.
// getLoginUrl() — запит до бекенду ЕРП, що повертає { url } одноразового входу.
function EmbeddedApp({ title, getLoginUrl, errorText }) {
  const [url, setUrl] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    getLoginUrl()
      .then((res) => {
        if (!cancelled) setUrl(res.data.url);
      })
      .catch((err) => {
        if (!cancelled) setError(err.response?.data?.detail || errorText);
      });
    return () => {
      cancelled = true;
    };
  }, [getLoginUrl, errorText]);

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  if (!url) {
    return (
      <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      component="iframe"
      src={url}
      title={title}
      allow="clipboard-read; clipboard-write; fullscreen"
      sx={{ flexGrow: 1, width: '100%', border: 0, display: 'block' }}
    />
  );
}

export default EmbeddedApp;
